module.exports = __webpack_public_path__ + "static/media/close-button-black.6b9a5638.svg";